"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicrofrontendRouter = void 0;
var web_ui_features_1 = require("@gruposantander/web-ui-features");
Object.defineProperty(exports, "MicrofrontendRouter", { enumerable: true, get: function () { return web_ui_features_1.MicrofrontendRouter; } });
//# sourceMappingURL=index.js.map